import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment } from "vue"

import { ref } from "vue";
import ProgressSpinner from "primevue/progressspinner";
import Dialog from "primevue/dialog";
import { createReusableTemplate, get, set } from "@vueuse/core";

type ISpinner = {
  className?: string;
  hasFull: boolean;
  loadMore?: boolean;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'spinner',
  props: {
    className: null,
    hasFull: { type: Boolean },
    loadMore: { type: Boolean }
  },
  setup(__props: any, { expose }) {

const [DefineSpinner, ReuseSpinner] = createReusableTemplate();



const visible = ref(true);

const getVisible = () => get(visible);

const show = () => set(visible, true);

const hide = () => set(visible, false);

// eslint-disable-next-line no-undef
expose({
  getVisible,
  show,
  hide,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(DefineSpinner), null, {
      default: _withCtx(() => [
        (visible.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["flex flex-wrap align-items-center justify-content-center absolute w-full h-full animation-duration-500", [
        visible.value ? 'fadein' : 'fadeout',
        __props.loadMore ? 'h-6rem bg-transparent' : 'h-full bg-gray',
        __props.className ? __props.className : '',
      ]])
            }, [
              _createVNode(_unref(ProgressSpinner), { class: "vertical-align-middle" })
            ], 2))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (__props.hasFull)
      ? (_openBlock(), _createBlock(_unref(Dialog), {
          key: 0,
          visible: visible.value,
          "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((visible).value = $event)),
          class: "message-loading",
          position: "center"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(ReuseSpinner))
          ]),
          _: 1
        }, 8, ["visible"]))
      : (_openBlock(), _createBlock(_unref(ReuseSpinner), { key: 1 }))
  ], 64))
}
}

})